import gql from "graphql-tag";

export const UPDATE_AGENT_MUTATION = gql`
  mutation UpdateAgent($input: AgentInput!) {
    updateAgent(input: $input) {
      statusCode
      message
      agent {
        tenantId
        agentId
        name
        description
        llmModel
        narrativeInstructions
        codeInterpreter
        userInput
        idleSessionTimeout
        actionGroups {
          groupName
          description
          actionType
        }
      }
    }
  }
`;
